import { c as _c } from "react/compiler-runtime";
import { VStack } from '@chakra-ui/react';
import { BizplanAccountsBlock } from '@src/components/sco/Account/StartupsUnlimitedAccounts/BizplanAccountsBlock';
import { FundableAccountsBlock } from '@src/components/sco/Account/StartupsUnlimitedAccounts/FundableAccountsBlock';
import { LaunchrockAccountsBlock } from '@src/components/sco/Account/StartupsUnlimitedAccounts/LaunchrockAccountsBlock';
type StartupsUnlimitedAccountsProps = {};
export const StartupsUnlimitedAccounts = props => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <VStack gap={4}><BizplanAccountsBlock /><LaunchrockAccountsBlock /><FundableAccountsBlock /></VStack>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};